import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fromFilter } from 'store/selectors';
import { setFilterMiddleware } from 'store/actions';

import { FilterDropdown } from 'components';

const FilterDropdownContainer = props => <FilterDropdown {...props} />;
FilterDropdownContainer.propTypes = {
  filter: PropTypes.string,
  middleware: PropTypes.string,
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  selected: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
};

const mapStateToProps = (state, { filter, middleware, defaultValue }) => ({
  selected: fromFilter.getFilterMiddleware(state, filter, middleware) || defaultValue,
});

const mapDispatchToProps = (dispatch, { filter, middleware }) => ({
  onChange: value => dispatch(setFilterMiddleware(filter, middleware, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterDropdownContainer);



// WEBPACK FOOTER //
// ./src/containers/FilterDropdown.js